"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTeamsOptions = buildTeamsOptions;
exports.buildTeamMemberOptions = buildTeamMemberOptions;
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = __importDefault(require("lodash"));
const lexico = new lexico_1.default();
function buildTeamsOptions({ teams }) {
    return lodash_1.default.map([{ id: 'all', name: 'All Teams' }, ...teams], team => ({
        id: team?.id,
        label: team.name,
    }));
}
function buildTeamMemberOptions({ allMembersFromAllTeams, filterTeam, isUserCompanyAdminOrSupport }) {
    let users;
    if (isUserCompanyAdminOrSupport) {
        const usersToSort = filterTeam?.users || allMembersFromAllTeams;
        users = usersToSort?.filter(user => user?.Roles?.length > 0 || user?.roles?.length > 0);
        const userOpts = lodash_1.default.map(users, user => ({
            id: user.Id || user?.userId,
            label: `${user.FirstName || user.firstName} ${user.LastName || user.lastName}`,
        }));
        return [{ id: 'all', label: lexico.trc('Wallet display label', 'All Members') }, ...userOpts];
    }
    else {
        users = filterTeam?.users;
        const userOpts = lodash_1.default.map(users, user => ({
            id: user?.userId,
            label: user?.fullName,
        }));
        return [{ id: 'all', label: lexico.trc('Wallet display label', 'All Members') }, ...userOpts];
    }
}
